import { useEffect, useState, useCallback } from 'react'
import styled from 'styled-components'

import Api from 'services/api'

import { color } from 'styles/colors'

import useSiteMessages from 'hooks/useSiteMessages'

import { useStoreContext } from 'hooks/StoreContext'

const UnreadSiteMessagesCount = () => {
  useSiteMessages({ getPublishedOnly: true })

  const { siteMessages, areSiteMessagesLoaded } = useStoreContext()
  const [unreadSiteMessageIds, setUnreadSiteMessageIds] = useState([])

  const fetchUnreadCount = useCallback(async () => {
    const [unreadRes, removedRes] = await Promise.all([
      Api.SiteMessagesUserRead.getUnread(),
      Api.SiteMessagesUserRead.getRemoved()
    ])

    const removedIds = removedRes.siteMessageIds || []
    const unreadIds = unreadRes.siteMessageIds || []

    setUnreadSiteMessageIds(
      unreadIds.filter((id) =>
        siteMessages.some((msg) => msg.id === id && !removedIds.includes(id))
      )
    )
  }, [siteMessages])

  useEffect(() => {
    if (!areSiteMessagesLoaded) return

    fetchUnreadCount()

    const intervalId = setInterval(fetchUnreadCount, 60 * 1000)
    window.addEventListener('site-messages-read', fetchUnreadCount)

    return () => {
      clearInterval(intervalId)
      window.removeEventListener('site-messages-read', fetchUnreadCount)
    }
  }, [areSiteMessagesLoaded, fetchUnreadCount])

  const unreadCount = unreadSiteMessageIds.length

  return unreadCount > 0 ? (
    <S.Badge data-testid="unreadSiteMessageCount">{unreadCount}</S.Badge>
  ) : null
}

export default UnreadSiteMessagesCount

const S = {
  Badge: styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: ${color('notificationDot')};
    color: ${color('navLinkText')};
    font-size: 10px;
    font-weight: bold;
    min-width: 15px;
    height: 15px;
    padding: 0 4px;
    border-radius: 50%;
    margin-left: -4px;
    box-sizing: border-box;
  `
}
